<template>
  <div class="">
    <div
      class="text-sm flex-1 py-4 px-2.5 opacity-70 text-white flex items-center justify-between"
      :class="{
        // ' !opacity-100': (showAdd || showDelete) && hover
      }"
    >
      <!-- title -->
      <template v-if="!$slots.title">
        <div
          class="flex justify-between items-center w-full"
          @mousemove="() => (hover = true)"
          @mouseleave="() => (hover = false)"
        >
          <div>
            <span> {{ title }}</span>
            <a-tooltip v-if="tooltip" :title="tooltip">
              <icon
                class="ml-1 !cursor-default"
                :class="{}"
                icon="help.svg"
                :width="14"
                :height="14"
                fill="none"
              />
            </a-tooltip>
          </div>
          <div
            v-if="showAdd"
            class="cursor-pointer"
            @click.stop="
              () => (showAdd && emits('add')) || (showDelete && emits('delete'))
            "
          >
            <icon :icon="'add.svg'" :width="14" :height="14" fill="none" />
          </div>
          <div
            v-if="showDelete"
            class="cursor-pointer"
            @click.stop="
              () => (showAdd && emits('add')) || (showDelete && emits('delete'))
            "
          >
            <icon :icon="'minus.svg'" :width="14" :height="14" fill="none" />
          </div>
        </div>
      </template>
      <template v-else>
        <slot name="title" />
      </template>
    </div>
    <div
      v-if="visible"
      class="!-mt-[6px]"
      :class="{
        ' rounded-2xl py-1  bg-black-card': card
      }"
    >
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';

defineProps({
  title: {
    type: String,
    default: ''
  },
  tooltip: {
    type: String,
    default: ''
  },
  showAdd: {
    type: Boolean,
    default: false
  },

  showDelete: {
    type: Boolean,
    default: false
  },

  card: {
    type: Boolean,
    default: false
  },
  // 是否显示group内容
  visible: {
    type: Boolean,
    default: true
  }
});
const emits = defineEmits<{
  (event: 'add'): void;
  (event: 'delete'): void;
}>();
const hover = ref(false);
</script>

<style lang="less" scoped></style>
